import React, { useCallback, useMemo } from "react";
import PropTypes from "prop-types";
import { Provider, useDispatch, useSelector } from "react-redux";
import ShortsPlayer from "./shorts-player";
import createStore from "../../redux/createStore";
import SupportForm from "../upgrade/supportForm";
import FeedbackModal from "../../publish/feedback-modal";
import ActionTypes from "../../constants/action-types";

/**
 * Component to create seperate store for each player.
 * @param {params: string, projectDetails: object, userDetails: object, shortData: object} props
 * @returns
 */
const ShortsWrapper = ({ onBack, feedbackType, onLike, onDislike, ...props }) => {
  const parentDispatch = useDispatch();
  const newStore = useMemo(() => createStore(true), []);
  const appReducer = useSelector((state) => state.app);
  const feedbackModal = appReducer.get("feedbackModal");
  const showFeedbackModal = feedbackModal.get("show");
  const appReframeData = appReducer.get("reframeData");

  const showPricingModal = useCallback((arg = {}) => {
    parentDispatch({
      type: ActionTypes.SET_SHOW_PRICING_MODAL,
      payload: {
        show: true,
        ...arg,
      },
    });
  }, [parentDispatch]);

  return (
    <Provider store={newStore}>
      <ShortsPlayer
        {...props}
        appReframeData={appReframeData}
        onBack={onBack}
        showPricingModal={showPricingModal}
        feedbackType={feedbackType}
        onLike={onLike}
        onDislike={onDislike}
        parentDispatch={parentDispatch}
      />
      <SupportForm />
      <FeedbackModal
        showModal={showFeedbackModal}
      />
    </Provider>
  );
};

ShortsWrapper.propTypes = {
  onBack: PropTypes.func,
  inModal: PropTypes.bool,
  projectDetails: PropTypes.object,
  userDetails: PropTypes.object,
  shortData: PropTypes.object,
  params: PropTypes.object,
  feedbackType: PropTypes.oneOf(["like", "dislike", null]),
  onLike: PropTypes.func,
  onDislike: PropTypes.func,
};

export default ShortsWrapper;
